import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'miq-section-options-filter',
  template: `
    <div class="section-options-filter-wrapper">
      <div class="section-options-filter-title">{{ title | uppercase }}</div>
      <div class="searchContainer section-options-filter-search-container">
        <input
          class="searchBox section-options-filter-search-box"
          autocomplete="no-autofill"
          [formControl]="searchFormControl"
          type="search"
          [placeholder]="placeholder"
        />
        <mat-icon class="search section-options-filter-search-icon">search</mat-icon>
      </div>
    </div>
  `,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatIconModule],
  styleUrls: ['./section-options-filter.component.scss'],
})
export class SectionOptionsFilterComponent {
  @Input() title: string;
  @Input() placeholder: string;
  @Input() showCancelButton: boolean;
  @Input() searchFormControl: FormControl;
}
